<template>
  <div class="d-flex w-100">
    <div v-if="error" class="alert alert-warning mt-1 mb-0 text-center mx-auto">
      {{ errorMessage }}<br />
      <BushelBtn variant="primary" class="mt-2" @click="error = false"> Dismiss </BushelBtn>
    </div>
    <div v-else-if="!signupType" class="d-flex flex-column justify-content-between w-100" style="padding: 0 0.75rem 0.75rem">
      <div class="d-flex flex-column align-items-center mb-3">
        <h1 class="mb-0">Welcome!</h1>
        <h5>are you trying to</h5>
      </div>
      <div class="d-flex flex-column justify-content-around w-100">
        <BushelBtn :style="{ padding: '1.5rem 0' }" variant="success" @click="signupType = 'create'"> Create a New Company </BushelBtn>
        <BushelBtn :style="{ padding: '1.5rem 0', marginTop: '2rem !important' }" @click="signupType = 'join'">
          <div v-if="joiningCompanyName">
            <p class="mb-0">Join</p>
            <p class="mb-0">
              {{ joiningCompanyName }}
            </p>
          </div>
          <div v-else>Join an Existing Company</div>
        </BushelBtn>
      </div>
    </div>
    <div v-else-if="signupType == 'create'" @keyup.enter="register">
      <BushelTextInputMaterial
        type="text"
        name="registerCompanyName"
        :thin="true"
        :error="submitted && !formData.companyName"
        label-active="Company Name"
        autocomplete="companyName"
        :value="formData.companyName"
        :style="{ paddingTop: 0 }"
        @input="$emit('input', { field: 'companyName', value: $event })"
      />
      <BushelSelect
        class="pt-3"
        :value="formData.subscriptionType"
        :options="subscriptionTypes"
        :error="submitted && !formData.subscriptionType"
        :searchable="false"
        no-deselect
        no-padding
        label="text"
        label-active="Are you a..."
        @select="$emit('input', { field: 'subscriptionType', value: $event })"
      />
      <div id="region-selector-container" class="pt-3">
        <BushelSelect
          class="w-100"
          :value="formData.companyCountry"
          :options="countries"
          :error="submitted && !formData.companyCountry"
          label="text"
          no-deselect
          no-padding
          label-active="Country"
          @select="$emit('input', { field: 'companyCountry', value: $event })"
        />
        <BushelSelect
          class="w-100"
          :value="formData.companyState"
          :options="states"
          :error="submitted && !formData.companyState"
          no-deselect
          no-padding
          label="text"
          label-active="State"
          @select="$emit('input', { field: 'companyState', value: $event })"
        />
      </div>
      <BushelTextInputMaterial
        type="text"
        name="registerName"
        :thin="true"
        :error="submitted && !formData.name"
        label-active="Your Name"
        autocomplete="name"
        :value="formData.name"
        @input="$emit('input', { field: 'name', value: $event })"
      />
      <BushelTextInputMaterial
        type="email"
        name="registerEmail"
        :thin="true"
        :error="submitted && !validateEmail(formData.email)"
        :label-active="'Email'"
        autocomplete="email"
        :value="formData.email"
        @input="$emit('input', { field: 'email', value: $event })"
      />
      <BushelFlagMaterial
        :default-country="formData.country"
        name="registerPhone"
        type="tel"
        :thin="true"
        :country="formData.companyCountry && formData.companyCountry.value ? formData.companyCountry.value.toLowerCase() : 'us'"
        :error="submitted && !formData.phone"
        :label-active="'Phone'"
        :value="formData.phone"
        @input="$emit('input', { field: 'phone', value: $event })"
      />
      <div style="display: grid; grid-template-columns: 1fr 1fr; grid-gap: 1rem">
        <BushelTextInputMaterial
          thin
          name="registerPassword"
          :error="submitted && formData.password.length < 8"
          :error-text="'8 char min, letters, mixedCase, numbers, symbols'"
          :type="showPassword ? 'text' : 'password'"
          :label-active="'Password'"
          :value="formData.password"
          :message="'8 char min, letters, mixedCase, numbers, symbols'"
          @input="$emit('input', { field: 'password', value: $event })"
        />
        <BushelTextInputMaterial
          thin
          name="registerPasswordConfirm"
          :error="submitted && (!formData.passwordConfirm || formData.passwordConfirm != formData.password)"
          :error-text="'must match password'"
          :type="showPassword ? 'text' : 'password'"
          :label-active="'Confirm'"
          :value="formData.passwordConfirm"
          :append-icon="showPassword ? 'fas fa-eye' : 'fas fa-eye-slash'"
          :message="'8 char min, letters, mixedCase, numbers, symbols'"
          @icon-clicked="showPassword = !showPassword"
          @input="$emit('input', { field: 'passwordConfirm', value: $event })"
        />
      </div>
      <div>
        <p class="text-sm">8 char min, letters, mixedcase, numbers, and symbols</p>
      </div>
      <div class="d-flex justify-content-center align-items-center position-relative m-2 user-select-none">
        <div class="custom-checkbox" :style="{ paddingLeft: 0, paddingRight: '0.25rem' }">
          <input
            id="acceptTerms"
            :value="formData.acceptTerms"
            name="acceptTerms"
            type="checkbox"
            :checked="formData.acceptTerms"
            @input="toggleCheckbox"
          />
          <label for="acceptTerms" class="cursor-pointer" :class="{ checkboxLabelError: submitted && !formData.acceptTerms }">
            <span class="checkbox-box" dusk="register-checkbox" />
            <div class="small">I Accept</div>
          </label>
        </div>
        <span class="text-success small text-nowrap clickable" @click="showTerms = !showTerms"> Terms And Conditions </span>
      </div>
      <button class="btn btn-success w-100" dusk="register-button" :disabled="submitting" @click="register">
        Register
        <i v-if="submitting" class="fas fa-circle-notch fa-spin" />
      </button>
    </div>
    <div v-else-if="signupType == 'join'" class="d-flex flex-column justify-content-between w-100">
      <div v-if="joiningCompanyName" class="d-flex flex-column align-items-center">
        <h3 class="mb-0">Welcome!</h3>
        <h3 class="mb-1">Create a user to join</h3>
        <h3 class="mb-3">
          {{ joiningCompanyName }}
        </h3>
        <h5 class="text-center" :style="{ fontSize: '1.18rem', maxWidth: '80%' }">
          <BushelTextInputMaterial
            type="text"
            name="registerName"
            :thin="true"
            :error="submitted && !formData.name"
            label-active="Your Name"
            autocomplete="name"
            :value="formData.name"
            :style="{ paddingTop: 0 }"
            @input="$emit('input', { field: 'name', value: $event })"
          />
          <BushelTextInputMaterial
            type="email"
            name="registerEmail"
            :thin="true"
            :error="submitted && !validateEmail(formData.email)"
            :label-active="'Email'"
            autocomplete="email"
            :value="formData.email"
            @input="$emit('input', { field: 'email', value: $event })"
          />
          <BushelFlagMaterial
            :default-country="formData.country"
            name="registerPhone"
            type="tel"
            :thin="true"
            :error="submitted && !formData.phone"
            :label-active="'Phone'"
            :value="formData.phone"
            @country-selected="onSelectCountry"
            @input="$emit('input', { field: 'phone', value: $event })"
          />
          <div style="display: grid; grid-template-columns: 1fr 1fr; grid-gap: 1rem">
            <BushelTextInputMaterial
              thin
              name="registerPassword"
              :error="submitted && formData.password.length < 8"
              :error-text="'8 char min, letters, mixedCase, numbers, symbols'"
              :type="showPassword ? 'text' : 'password'"
              :label-active="'Password'"
              :value="formData.password"
              :message="'8 char min, letters, mixedCase, numbers, symbols'"
              @input="$emit('input', { field: 'password', value: $event })"
            />
            <BushelTextInputMaterial
              thin
              name="registerPasswordConfirm"
              :error="submitted && (!formData.passwordConfirm || formData.passwordConfirm != formData.password)"
              :error-text="'must match password'"
              :type="showPassword ? 'text' : 'password'"
              :label-active="'Confirm'"
              :value="formData.passwordConfirm"
              :append-icon="showPassword ? 'fas fa-eye' : 'fas fa-eye-slash'"
              :message="'8 char min, letters, mixedCase, numbers, symbols'"
              @icon-clicked="showPassword = !showPassword"
              @input="$emit('input', { field: 'passwordConfirm', value: $event })"
            />
          </div>
          <div>
            <p class="text-sm">8 char min, letters, mixedcase, numbers, and symbols</p>
          </div>
          <div class="d-flex justify-content-center align-items-center position-relative m-2 user-select-none">
            <div class="custom-checkbox" :style="{ paddingLeft: 0, paddingRight: '0.25rem' }">
              <input
                id="acceptTerms"
                :value="formData.acceptTerms"
                name="acceptTerms"
                type="checkbox"
                :checked="formData.acceptTerms"
                @input="toggleCheckbox"
              />
              <label for="acceptTerms" class="cursor-pointer" :class="{ checkboxLabelError: submitted && !formData.acceptTerms }">
                <span class="checkbox-box" dusk="register-checkbox" />
                <div class="small">I Accept</div>
              </label>
            </div>
            <span class="text-success small text-nowrap clickable" @click="showTerms = !showTerms"> Terms And Conditions </span>
          </div>
          <button class="btn btn-success w-100" dusk="register-button" :disabled="submitting" @click="register">
            Register
            <i v-if="submitting" class="fas fa-circle-notch fa-spin" />
          </button>
        </h5>
      </div>
      <div v-else>
        <div class="d-flex flex-column align-items-center">
          <h1 class="mb-0">Almost</h1>
          <h5 class="text-center mb-3" :style="{ fontSize: '1.18rem', maxWidth: '80%' }">
            To continue, request an invite link from your Company Administrator.
          </h5>
        </div>
        <BushelBtn variant="success" class="w-100 p-2" @click="signupType = undefined"> Back </BushelBtn>
      </div>
    </div>
    <BModal v-model="showTerms" :visible="showTerms" max-width="500" scrollable @hide="showTerms = false">
      <template #modal-title> Terms And Conditions </template>
      <Terms />
      <template #modal-footer>
        <BushelBtn variant="danger" ripple-color="danger" flat @click="disagree"> Disagree </BushelBtn>
        <BushelBtn variant="success" ripple-color="success" flat @click="agree"> Agree </BushelBtn>
      </template>
    </BModal>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import Terms from "@/components/common/Terms.vue";
import BushelFlagMaterial from "@/components/common/forms/BushelFlagMaterial.vue";
import BushelTextInputMaterial from "@/components/common/forms/BushelTextInputMaterial.vue";
import { validateEmail } from "@/services/helpers";

export default {
  components: { Terms, BushelFlagMaterial, BushelTextInputMaterial },
  props: {
    formData: { type: Object, required: true },
    countries: { type: Array, required: true },
    states: { type: Array, required: true },
    subscriptionTypes: { type: Array, required: true },
    joiningCompanyName: { type: String },
    createBrand: { type: Boolean, default: false },
  },
  emits: ["input"],
  data() {
    return {
      appEnv: APP_ENVIRONMENT,
      signupType: undefined,
      showPassword: false,
      showTerms: false,
      checkboxRequired: true,
      submitted: false,
      submitting: false,
      error: false,
      errorMessage: null,
    };
  },
  computed: {},
  watch: {
    "formData.isInvite": function (isInvite) {
      this.signupType = isInvite === undefined ? "join" : isInvite ? "create" : undefined;
    },
  },
  mounted() {
    if (this.joiningCompanyName) {
      this.signupType = "join";
    }

    if (this.createBrand) {
      this.signupType = "create";
    }
  },
  methods: {
    ...mapActions({
      registerAction: "auth/register",
      updateCompany: "companies/update",
    }),
    validateEmail,
    onSelectCountry({ name, iso2, dialCode }) {
      this.$emit("input", { field: "country", value: iso2 });
      this.$emit("input", { field: "countryCode", value: dialCode });
    },
    toggleCheckbox() {
      if (this.formData.acceptTerms == true) {
        this.disagree();
      } else {
        this.agree();
      }
    },
    agree() {
      this.showTerms = false;
      this.$emit("input", { field: "acceptTerms", value: true });
    },
    // handleRoutingToOrder(orderUUID) {
    //   api.get(`invoice/${orderUUID}`).then(
    //     (response) => {
    //       if (response.data && response.data.id) {
    //         const order = response.data;
    //
    //         //  The only type of company that would be registering to see an order is a buyer
    //         // if(order && this.user.current_company_id == order.seller_company_id) {
    //         //   this.$router.replace(`/orders/shipping/${orderUUID}`);
    //         // }
    //         // using a sneaky reg so I don't think this will come into play.
    //         if (order && (!order.buyer_company_id || (this.user.current_company_id == order.buyer_company_id)) {
    //           this.$router.replace(`/orders/receiving/${orderUUID}`);
    //         }
    //       }
    //     },
    //   );
    //
    //   // final catch if didn't work above
    //   this.$router.replace('/');
    // },
    disagree() {
      this.showTerms = false;
      this.$emit("input", { field: "acceptTerms", value: false });
    },
    async register() {
      this.submitted = true;
      this.submitting = true;
      if (
        this.validateEmail(this.formData.email) &&
        this.formData.phone &&
        this.formData.password.length >= 8 &&
        this.formData.passwordConfirm == this.formData.password &&
        this.formData.acceptTerms &&
        this.formData.name &&
        (this.formData.isInvite ||
          (this.formData.companyName && this.formData.subscriptionType && this.formData.companyCountry && this.formData.companyState))
      ) {
        const payload = {
          email: this.formData.email,
          name: this.formData.name,
          phone: this.formData.phone,
          phone_country: this.formData.country,
          country_code: this.formData.countryCode,
          company_country_id: this.formData.companyCountry?.id,
          company_state_id: this.formData.companyState?.id,
          company_name: this.formData.companyName,
          invitation: this.formData.invitation,
          buyer_invitation: this.formData.buyerInvitation,
          brand_invitation: this.formData.brandInvitation,
          subscription: this.formData.subscriptionType?.id,
          password: this.formData.password,
        };
        if (!this.formData.isInvite) {
          payload.company_name = this.formData.companyName;
          payload.company_country_id = this.formData.companyCountry?.id;
          payload.company_state_id = this.formData.companyState?.id;
        }
        this.registerAction(payload).then((response) => {
          if (response == "success") {
            if (this.formData.buyerInvitation) {
              this.$router.replace(
                `/buyer-onboard?buyer_invitation=${this.$route.query.buyer_invitation}&invitation_email=${this.$route.query.invitation_email}`,
              );
              // this.$router.replace('/buyer-onboard');

              // else if (this.formData.orderUuid) {
              //   this.handleRoutingToOrder(this.formData.orderUuid);
              // }
            } else {
              this.$router.replace("/");
            }
          } else {
            this.error = true;
            if (response == "email taken") {
              this.errorMessage = "Sorry this email is already in use.";
            } else if (response && response.length && (typeof response === "string" || response instanceof String)) {
              this.errorMessage = response;
            } else {
              this.errorMessage = "Something went wrong. If you already have an account, please login or reset your password instead";
            }
            this.submitting = false;
          }
        });
      } else {
        this.submitting = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "@sass/_variables.scss";
.checkboxLabelError .checkbox-box {
  border: 2px solid $danger;
}
.checkboxLabelError div {
  color: $danger;
}

#region-selector-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(9.4rem, 1fr));
  grid-gap: 1rem;
}
</style>
